import * as types from "./types";
import {
  getColoriSidebar,
  getColoriHeader,
  getColoriBody,
  getColoriCard,
  getColoriFooter
} from "./services";

export async function getColoriSidebarAction({ commit }) {
  try {
    const { data } = await getColoriSidebar();
    commit(types.SET_SIDEBAR_COLORS, data);
  } catch (e) {
    console.log(e);
  }
}

export async function getColoriHeaderAction({ commit }) {
  try {
    const { data } = await getColoriHeader();
    commit(types.SET_HEADER_COLORS, data);
  } catch (e) {
    console.log(e);
  }
}
export async function getColoriBodyAction({ commit }) {
  try {
    const { data } = await getColoriBody();
    commit(types.SET_BODY_COLORS, data);
  } catch (e) {
    console.log(e);
  }
}
export async function getColoriCardAction({ commit }) {
  try {
    const { data } = await getColoriCard();
    commit(types.SET_CARD_COLORS, data);
  } catch (e) {
    console.log(e);
  }
}
export async function getColoriFooterAction({ commit }) {
  try {
    const { data } = await getColoriFooter();
    commit(types.SET_FOOTER_COLORS, data);
  } catch (e) {
    console.log(e);
  }
}
